import { createTestIDGetter } from '@24i/nxg-core-utils/src/test-utils';

export enum EPISODE_PICKER_TEST_IDS {
    SEASONS_DROPDOWN_ITEM_BUTTON = 'seasons_dropdown_button',
}

export const getEpisodePickerTestID = createTestIDGetter('episode_picker');
